import * as React from "react";
import { SvgIcon, SvgIconProps, makeStyles, Theme } from "@material-ui/core";

type Props = styleProps & SvgIconProps;

type styleProps = {
  fillColor?: React.CSSProperties["color"];
  backgroundColor?: React.CSSProperties["color"];
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: ({ fillColor, backgroundColor }) => ({
    "& .a": { fill: fillColor || "rgba(0,0,0,0.1)" },
    "& .b": { fill: backgroundColor || " #fff", fillRule: "evenodd" },
    "& .c": { filter: "url(#a)" },
  }),
}));

function WMLettersLogo({ fillColor, backgroundColor, ...props }: Props) {
  const c = useStyles({ fillColor, backgroundColor });

  return (
    <SvgIcon className={c.root} viewBox="0 0 83.403 87.75" {...props}>
      <g transform="translate(4.5 2.5)">
        <g className="c" transform="matrix(1, 0, 0, 1, -4.5, -2.5)">
          <path className="a" d="M0,0H74.4V78.75H0Z" transform="translate(4.5 2.5)" />
        </g>
        <g transform="translate(-14060.238 -5806)">
          <path
            className="b"
            d="M3869.32,793h-8.792l-3.1,8.983c-.421,1.376-.994,3.173-1.491,4.817h-.038l.153-13.8h-8.792L3840,818.879h7.607l2.294-10.512c.42-1.949.688-3.784.994-5.734h.115l-.153,16.246h5.811l3.708-10.589c.688-1.911,1.223-3.784,1.8-5.657h.115l-1.988,16.246h7.416l1.262-20.222Z"
            transform="translate(10255.716 5043)"
          />
          <path
            className="b"
            d="M4078.7,2h-6.918l-3.25,10.436c-.535,1.873-1.033,4.052-1.491,5.7h-.077c.038-1.911.077-3.784.077-5.7L4066.928,2h-6.117l-3.478,10.436c-.612,1.8-1.032,3.823-1.567,5.772h-.039c.039-1.95.192-3.823.192-5.772L4056,2h-7l1.721,25.918,6.881-.038,3.21-10.474c.65-2.1.994-3.937,1.453-5.734h.077c-.039,1.8-.192,3.823-.154,5.734l.229,10.474h6.843L4077.4,5.632Z"
            transform="translate(10022.674 5834)"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default WMLettersLogo;
